/* eslint-disable @typescript-eslint/naming-convention */
export enum AddressType {
    PICKPOST = 'pickpost',
    POST_LAGERND = 'postlagernd',
    MY_POST_24 = 'mypost24'
}
